import { useDispatch, useSelector } from "react-redux";
import { setAgreements, setCurrentUser, setEmployees } from "./reducer";
import React from "react";
import { getFirebaseBackend } from "../../helpers/firebase_helper";

export const useCurrentUser = () => {
  const state = useSelector((state) => state.Auth);

  const currentUser = state?.currentUser

  return currentUser || null;
};

export const useIsCurrentUserComplete = () => {
  const currentUser = useCurrentUser();

  return React.useMemo(() => {
    if (!currentUser) return false;

    const requiredFields = [
      "firstName",
      "lastName",
      "phoneNumber",

      "companyName",
      "companyAddress",
      "zipCode",
      "state",
    ];

    const userFields = Object.keys(currentUser);

    return requiredFields.every((field) => userFields.includes(field));
  }, [currentUser]);
};

export const useSetCurrentUser = () => {
  const dispatch = useDispatch();

  return (user) => dispatch(setCurrentUser(user));
};

export const useGetUserEmployees = () => {
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();

  return React.useCallback(async () => {
    const db = getFirebaseBackend().firestore;

    try {
      const snapshot = await db
        .collection("employees")
        .where("employerId", "==", currentUser.uid)
        .get();

      const employees = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      dispatch(setEmployees(employees));

      return employees;
    } catch (err) {
      console.log(err);
      return null;
    }
  }, [currentUser]);
};

export const useAgreements = () => {
  const { agreements } = useSelector((state) => state.Auth);

  return agreements;
};

export const useSetAgreements = () => {
  const dispatch = useDispatch();

  return (agreements) => dispatch(setAgreements(agreements));
}